module.exports = __webpack_public_path__ + "img/cd.9d1d35c8.svg";